import { Brands } from '@jpi-cloud-web-pro/jpi-cloud-shared/config/brands';
import { AlarmStatus } from '@jpi-cloud-web-pro/jpi-cloud-shared/types';

export const ALARM_STATUSES = {
  ACTIVE: AlarmStatus.Active,
  DISMISSED_BY_DEVICE: AlarmStatus.DismissedByDevice,
  RESET_BY_USER_ON_DEVICE: AlarmStatus.ResetByUserOnDevice,
  RESET_BY_USER_FROM_CLOUD: AlarmStatus.ResetByUserFromCloud,
} as const;

export const ALARM_TYPES = {
  ALL: 'all',
  ACTIVE: 'active',
};

export const ELIGIBLE_BRANDS_FOR_HIDING_HISTORY = [Brands.AIT, Brands.NOVELAN, Brands.CTA];

export const BRANDS_WITH_NOEM_FIRMWARE = [Brands.AIT, Brands.NOVELAN, Brands.CTA];

export const resetAlarmErrorMessages = {
  404: {
    id: 'alarms.error.request.reset-alarm.device-not-found',
    defaultMessage: "The alarm can't be reset. Check that the device is registered in the system.",
  },
  409: {
    id: 'alarms.error.request.reset-alarm.device-disconnected',
    defaultMessage: "The alarm can't be reset. Check that the device is connected.",
  },
};

export const activateAidModeErrorMessages = {
  404: {
    id: 'alarms.error.request.activate-aid-mode.device-not-found',
    defaultMessage: "Can't activate aid mode. Check that device is registered in system.",
  },
  409: {
    id: 'alarms.error.request.activate-aid-mode.device-disconnected',
    defaultMessage: "Can't activate aid mode. Check that device is connected.",
  },
};

export const unknownErrorMessage = {
  id: 'generic.error.request.unknown',
  defaultMessage: 'An error has occurred. Try again later.',
};
